// extracted by mini-css-extract-plugin
module.exports = {"accounts__connect-link":"Accounts_accounts__connect-link__YmCWZ"};